// @flow

// Libraries
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'

// Sagas
import rootSaga from 'Sagas/'

// Store
import configureStore from 'Redux/CreateStore'

// Reducer
import { reducer as startupReducer } from 'Redux/StartupRedux'

// Resources
import { navReducer } from 'Navigation/NavigationRouter'
import { reducer as webSocketReducer } from 'WebSocket/Redux'
import { rootReducer as apiReducer } from 'Resources/ApiResource'
import { rootReducer as langReducer } from 'Resources/LangResource'
import { rootReducer as authReducer } from 'Resources/AuthResource'
import { rootReducer as filmReducer } from 'Resources/FilmResource'
import { rootReducer as profileReducer } from 'Resources/ProfileResource'
import { rootReducer as basinReducer } from 'Resources/BasinResource'
import { rootReducer as siloReducer } from 'Resources/SiloResource'
import { rootReducer as eventReducer } from 'Resources/EventResource'
import { rootReducer as scenarioReducer } from 'Resources/ScenarioResource'
import { rootReducer as siteReducer } from 'Resources/SiteResource'
import { rootReducer as tankReducer } from 'Resources/TankResource'
import { rootReducer as commentReducer } from 'Resources/CommentResource'

// Config
import { ReduxPersist } from 'Config'

export default () => {
  /* ------------- Assemble The Reducers ------------- */
  let rootReducer = combineReducers({
    nav: navReducer,
    api: apiReducer,
    auth: authReducer,
    film: filmReducer,
    lang: langReducer,
    startup: startupReducer,
    profile: profileReducer,
    websocket: webSocketReducer,
    basin: basinReducer,
    silo: siloReducer,
    event: eventReducer,
    scenario: scenarioReducer,
    site: siteReducer,
    tank: tankReducer,
    comment: commentReducer
  })

  /* ------------- Config persistant store ------------- */
  if (ReduxPersist.active) {
    rootReducer = persistReducer(ReduxPersist.storeConfig, rootReducer)
  }

  return configureStore(rootReducer, rootSaga)
}
